import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BaseAccordionProps } from './types';
import { useBaseAccordion } from './useBaseAccordion';
import './BaseAccordion.scss';

export const BaseAccordion = (props: BaseAccordionProps) => {
  const { isExpanded, handleToggle } = useBaseAccordion(props);

  return (
    <Accordion
      expanded={isExpanded}
      onChange={handleToggle}
      className={`baseAccordion ${props.className || ''}`}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box className="accordionHeader">
          <Box className="accordionTitleSection">
            {props.icon}
            <Typography variant="h6" className="accordionTitle">
              {props.title}
            </Typography>
          </Box>
          <Box className="accordionRightSection">
            {props.badge}
            {props.headerActions && (
              <Box onClick={e => e.stopPropagation()}>
                {props.headerActions}
              </Box>
            )}
          </Box>
        </Box>
      </AccordionSummary>

      <AccordionDetails>{props.children}</AccordionDetails>
    </Accordion>
  );
};
